<!-- 创建商品 -->
<template>
	<div class="bg-white px-3 goods_create" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{ name: 'khgl_khgl_khxx' }" style="position: absolute;top: 12px;left: 200px;"><el-button size="mini">回到客户列表</el-button></router-link>
		<div style="border: 0.5px solid rgb(204, 204, 204,0.5);" class="m-2">
			<div class="m-3">销售线索记录</div>
			<div style="width: 100%;background: rgb(204, 204, 204,0.5);height: 0.5px;"></div>
			<div class="d-flex m-2">
				<div style="width: 50%;">
					<el-table :data="lists" style="width: 100%" size="mini">
						<el-table-column align="center" prop="id" label="编号" width="50"></el-table-column>
						<el-table-column align="center" prop="mc" label="客户名称"></el-table-column>
						<el-table-column align="center" prop="zrr" label="责任人"></el-table-column>
					</el-table>
				</div>
				<div style="width: 50%;">
					<div>
						<el-form ref="form" label-width="80px" style="margin-left: 20px;">
							<el-form-item label="转移到">
								<el-select v-model="zrr" placeholder="请选择" size="mini">
									<el-option v-for="item in yhs" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;justify-content: center;">
			<el-button type="primary" @click="submit" class="m-2" size="mini">确认提交</el-button>
			<router-link :to="{ name: 'khgl_khgl_khxx' }"><el-button type="info" size="mini" class="m-2">关闭窗口</el-button></router-link>
		</el-footer>
	</div>
</template>

<script>
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	inject: ['app', 'layout'],
	data() {
		return {
			lists: [],
			yhs: [],
			ids: [],
			zrr:'',
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	// 生命周期
	created() {
		this.lists = this.$route.params.i.khxx;
		this.ids = this.$route.params.i.ids;
		this.axios.get('/admin/managers/list', { token: true }).then(res => {
			this.yhs = res.data.data;
		});
		
	},
	methods: {
		onClick(e, editor) {},
		handleChange(value) {},
		//提交
		submit() {			
			let i = {
				zrr:this.zrr,
				ids:this.ids
			}
			console.log(i);
			this.axios.post('/admin/khxx/zykh', i,{
				token: true
			}).then(res => {
				this.$message({
					type: 'success',
					message: '转移成功'
				});
				this.$router.push({
					name: 'khgl_khgl_khxx'
				});
			})
		}
	}
};
</script>

<style>
.goods_create .el-form-item {
	margin-bottom: 15px;
}
.pt-a {
	padding-top: 20px;
}
</style>
